import $ from "jquery";
import axios from "axios";

const URL = '/rest/g-a-log/create';

export const dataLayerPush = (object) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(object);
    saveLog(object);
};

const saveLog = (object) => {
    axios.post(URL, {data: JSON.stringify(object)});
};